SAPO.namespace('Project.Video');



SAPO.Project.Video._ = function(k) {
    var v = SAPO.Project.Video.i18n[k];
    //if (k === undefined) { debugger; }
    if (!v) {
        return '[' + k + ']';
    }
    return v;
};


/**
 * translation keys are defined here
 *
 * @module i18n
 *
 * the default values are defined [here](/SAPO/Project/Video/src/i18n.js) (check object at the end of file)
 *
 * @attribute {Object} i18n
 */
SAPO.Project.Video.i18n = {
    implUnavailableErrorMsg:      'Necessita usar outro browser<br/>ou instalar o Flash Player.',
    noSVMetadataErrorMsg:         'O vídeo que tentou ver não se encontra disponível<br/><br/>Pedimos desculpa pelo incómodo',
    noVideoSourceErrorMsg:        'O vídeo que tentou ver não se encontra disponível<br/><br/>Pedimos desculpa pelo incómodo',
    unknownErrorMsg:              'Problema a carregar vídeo.',
    withoutCorsOrFlashErrorMsg:   'Sem Flash. Necessita usar outro browser<br/>ou instalar o Flash Player.',
    flashUnavailableErrorMsg:     'Sem Flash. Necessita usar outro browser<br/>ou instalar o Flash Player.',
    noSVPlaylistErrorMsg:         'Erro a carregar playlist',
    noStreamErrorMsg:             'Direto não está a emitir',
    playlistLoadMoreTitle:        'Carregar mais vídeos',
    playlistNext:        'Seguinte: ',
    playlistPrev:        'Anterior: ',
    adTitle:             'Anúncio',
    closeTitle:          'Fechar',
    durationTitle:       'Duração do vídeo',
    goToSVTitle:         'Ver no SAPO Vídeos',
    goToSVAuthorTitle:   'Ver página do autor no SAPO Vídeos',
    linearAdTitle:       'Publicidade linear',
    liveTitle:           'Direto',
    metadataTitle:       'Informação',
    moreTitle:           'Mostra/esconde funcionalidades',
    muteTitle:           'Tirar som',
    nextPageTitle:       'Página seguinte',
    nonlinearAdTitle:    'Publicidade não-linear',
    pageTitle:           'Página',
    pauseTitle:          'Pausar',
    playTitle:           'Tocar',
    playPauseTitle:      'Tocar/parar',
    previousPageTitle:   'Página anterior',
    pubTitle:            'PUB',
    qualityTitle:        'Qualidade do vídeo',
    replayTitle:         'Rever',
    resizeTitle:         'Redimensionar',
    resize1Title:        'Restaurar tamanho',
    resizeFullTitle:     'Ver em ecrã inteiro',
    shareTitle:          'Partilhar',
    shareLinkTitle:      'Link',
    shareEmbedTitle:     'Embed',
    shareSocialTitle:    'Social',
    skipTitle:           'Saltar PUB',
    subtitlesTitle:      'Legendas',
    timeTitle:           'Tempo no vídeo',
    unmuteTitle:         'Repor som',
    volumeTitle:         'Volume',
    volumeSliderTitle:   'Volume'
};
